<template>
  <div class="usercenter-con">
    <div class="search">
      <el-input class="ipt" v-model="searchText" placeholder="请输入图片名称/ID"></el-input>
      <el-button class="btn" type="primary" @click="search">搜 索</el-button>
    </div>
    <el-table class="table-list" :data="tableData" stripe border>
      <el-table-column label="缩略图(点击查看大图)">
        <template slot-scope="scope">
          <img class="img" :src="scope.row.img" @click="preview(scope.$index)" />
        </template>
      </el-table-column>
      <el-table-column prop="sellDate" label="出售时间"></el-table-column>
      <el-table-column prop="imgName" label="图片名称"></el-table-column>
      <el-table-column prop="imgId" label="图片ID"></el-table-column>
      <el-table-column prop="authType" label="授权类型"></el-table-column>
      <el-table-column prop="income" label="授权分成收入(元)"></el-table-column>
      <!-- 无数据 -->
      <div slot="empty">
        <defaultCon
          :defaultText="noDataOp.defaultText" 
          :defaultBtnList="noDataOp.defaultBtnList" 
        >
        </defaultCon>
      </div>
    </el-table>
    <!-- 分页 -->
    <div class="page-wrap">
      <el-pagination background
        layout="prev, pager, next"
        :total="100">
      </el-pagination>
    </div>
    <!-- 不是签约供稿人 -->
    <defaultCon v-if="!ifSign"
      :defaultImg="notSignOp.defaultImg" 
      :defaultText="notSignOp.defaultText" 
      :defaultBtnList="notSignOp.defaultBtnList" 
    >
    </defaultCon>
    <!-- 大图预览 -->
    <previewImg :imgList="previewImgList" ref="previewImg"></previewImg>
  </div>
</template>
<script>
import previewImg from '@/components/previewImg'
export default {
  inject:['setTab'], //tab选中
  components: {
	  previewImg,
  },
  data() {
    return {
      ifSign:true, //是否签约
      searchText:'',// 搜索内容
      previewImgList:[],
      downloadImgSrc:'', //下载链接
      tableData: [
        {
          img: 'http://dy-allimage.oss-cn-hangzhou.aliyuncs.com/uploads/d6b/9d0/d6b9d0a3e898000e13d22a2e15072555.jpg',
          sellDate: '2021-01-29  17:17:17',
          imgName:'图片名称111',
          imgId:'11111',
          authType:'标准授权',
          income:'999.99'
        },{
          img: 'http://dy-allimage.oss-cn-hangzhou.aliyuncs.com/uploads/9a9/78a/9a978a009d5cc5c4cbd63a877cb37c02.jpg',
          sellDate: '2021-01-29  17:17:17',
          imgName:'图片名称111',
          imgId:'11111',
          authType:'标准授权',
          income:'999.99'
        },
      ],
      notSignOp:{ //未签约显示信息
        defaultImg:require('@/assets/img/notsign.png'),
        defaultText:'您还不是签约供稿人，请点击签约',
        defaultBtnList:[
          {
            btnText:'签约供稿人',
            btnUrl:'https://www.pai2345.com/wap/sign/index',
            ifRoute:false,
          },
        ],
      },
      noDataOp:{ //无列表数据
        defaultText:'没有查询到任何关于的结果,<br>您可以简化或缩短关键词再进行搜索',
        defaultBtnList:[],
      }
    };
  },
  mounted:function () {
    this.setTab(3) //tab选中
  },
  methods: {
    // 搜索
    search(){

    },
    // 预览大图
    preview(index){
      this.previewImgList = []
      this.tableData.map(item => {
        this.previewImgList.push(item.img)
      })
      this.$refs.previewImg.index = index
      this.$refs.previewImg.showPreview = true
    },
    // 图片下载
    downloadImg(img){
      this.downloadImgSrc = img
    },
    // 授权下载
    downloadAuth(img){
      this.downloadImgSrc = img
    }
  },
};
</script>
<style lang="scss" scoped>
  .search{
    margin-bottom: 20px;
    .ipt{
      width:350px;
    }
    .btn{
      width:100px;
      margin-left: 10px;
    }
  }
  .table-list{
    .img{
      width:100px;
      height:60px;
      object-fit: cover;
      cursor: pointer;
    }
  }
</style>
